import { Route } from "react-router-dom";
import CompanyLayout from "./CompanyLayout";
import SearchFlowABEntry from "./companyFlowEntries/SearchFlowABEntry";
import VafFlowABEntry from "./companyFlowEntries/VafFlowABEntry";
import RegFlowABEntry from "./companyFlowEntries/RegFlowABEntry";
import KftRegFlowABEntry from "./companyFlowEntries/KftRegFlowABEntry";
import RegFlowVersionB from "./regFlowVersionB/regFlow";
import KftRegFlowVersionB from "./kftRegFlowVersionB/kftRegFlow";
import VafFlowVersionB from "./vafFlowVersionB/vafFlow";
import StripeCheckout from "./components/stripePayment/StripeCheckout";
import StripeCTA from "./components/stripePayment/StripeCTA.jsx";
import DlpProviderProfile from "./dynamicListPages/dlpProviderProfile/dlpProviderProfile";
import DynamicListPages from "./dynamicListPages/dynamicListPages";
import WebflowSimulator from "./pages/WebflowSimulator.jsx";
import ProviderFeedback from "./providerFeedback/providerFeedback";
import ReferralDetails from "./referral/refDetails";
import ReferralPage from "./referral/referralPage";
import RequestOverview from "./requestOverview/requestOverview";
import HubSpotForm from "./pages/HubSpotForm.jsx";
import GeneralErrorPreview from "./searchFlowVersionB/steps/common/GeneralErrorPreview.jsx";

const companyRoutes = (
  <Route path="/company" element={<CompanyLayout />}>
    <Route path="webflow-simulator" element={<WebflowSimulator />} />
    <Route path="hubspotform" element={<HubSpotForm />} />
    <Route path="request/1" element={<SearchFlowABEntry />} />
    <Route path="request/vaf" element={<VafFlowABEntry />} />
    <Route path="request/vafb" element={<VafFlowVersionB />} />
    <Route
      path="request/vaf/checkout"
      element={
        <StripeCheckout
          priceId={process.env.REACT_APP_VAF_PRICE_ID}
          flowType="VAF"
        />
      }
    />
    <Route path="request/reg" element={<RegFlowABEntry />} />
    <Route path="request/regb" element={<RegFlowVersionB />} />
    <Route
      path="request/reg/checkout"
      element={
        <StripeCheckout
          priceId={process.env.REACT_APP_EV_PRICE_ID}
          flowType="REG"
        />
      }
    />
    <Route path="request/kftreg" element={<KftRegFlowABEntry />} />
    <Route path="request/kftregb" element={<KftRegFlowVersionB />} />
    <Route
      path="request/kftreg/checkout"
      element={
        <StripeCheckout
          priceId={process.env.REACT_APP_KFT_REG_PRICE_ID}
          flowType="KFTREG"
        />
      }
    />
    <Route path="request/feedback" element={<ProviderFeedback />} />
    <Route path="request/generalerror" element={<GeneralErrorPreview />} />
    <Route path="request_overview/:id" element={<RequestOverview />} />
    <Route path="refdetails" element={<ReferralDetails />} />
    <Route path="referral" element={<ReferralPage />} />
    <Route path="providerprofile/:id" element={<DlpProviderProfile />} />
    <Route path="providerlists/" element={<DynamicListPages />} />
    <Route path="stripe-cta" element={<StripeCTA />} />
  </Route>
);

export default companyRoutes;
